module.exports = __webpack_public_path__ + "img/1500718171.aadc40aa.jpg";